var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _g2, _path36, _path37, _path38, _path39, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackgroundWidgetMaps(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 854,
    height: 160,
    viewBox: "0 0 854 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20994_306981)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_20994_306981",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 854,
    height: 160
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M854 0H0V160H854V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_20994_306981)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M854 0H0V160H854V0Z",
    className: "illustration_primary-light"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M532.05 -141.865L486.281 226.216L487.274 226.34L533.043 -141.741L532.05 -141.865Z",
    fill: "#CCD7FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.144 -137.74L519.375 230.341L520.367 230.464L566.136 -137.617L565.144 -137.74Z",
    fill: "#CCD7FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.138 -133.628L552.369 234.453L553.362 234.577L599.131 -133.504L598.138 -133.628Z",
    fill: "#CCD7FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.132 -129.515L585.363 238.566L586.356 238.689L632.125 -129.392L631.132 -129.515Z",
    fill: "#CCD7FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.126 -125.403L618.357 242.678L619.35 242.801L665.119 -125.28L664.126 -125.403Z",
    fill: "#CCD7FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.121 -121.291L651.352 246.791L652.344 246.914L698.113 -121.167L697.121 -121.291Z",
    fill: "#CCD7FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727.861 -117.497L682.092 250.584L683.084 250.707L728.853 -117.374L727.861 -117.497Z",
    fill: "#CCD7FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M760.855 -113.385L715.086 254.696L716.078 254.819L761.847 -113.262L760.855 -113.385Z",
    fill: "#CCD7FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M793.849 -109.273L748.08 258.808L749.072 258.932L794.842 -109.149L793.849 -109.273Z",
    fill: "#CCD7FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M826.943 -105.148L781.174 262.933L782.166 263.056L827.935 -105.025L826.943 -105.148Z",
    fill: "#CCD7FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M859.937 -101.036L814.168 267.045L815.16 267.169L860.929 -100.912L859.937 -101.036Z",
    fill: "#CCD7FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.931 -96.9232L847.162 271.158L848.155 271.281L893.924 -96.7998L892.931 -96.9232Z",
    fill: "#CCD7FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.38 -193.408L93.6113 174.673L94.6037 174.797L140.373 -193.284L139.38 -193.408Z",
    fill: "#CCD7FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.474 -189.283L126.705 178.798L127.697 178.921L173.467 -189.16L172.474 -189.283Z",
    fill: "#CCD7FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.467 -185.171L159.698 182.911L160.691 183.034L206.46 -185.047L205.467 -185.171Z",
    fill: "#CCD7FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.462 -181.058L192.693 187.023L193.686 187.146L239.455 -180.935L238.462 -181.058Z",
    fill: "#CCD7FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.457 -176.946L225.688 191.135L226.68 191.258L272.449 -176.823L271.457 -176.946Z",
    fill: "#CCD7FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.451 -172.834L258.682 195.247L259.674 195.371L305.443 -172.71L304.451 -172.834Z",
    fill: "#CCD7FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.191 -169.04L289.422 199.041L290.414 199.164L336.183 -168.917L335.191 -169.04Z",
    fill: "#CCD7FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.185 -164.928L322.416 203.153L323.408 203.277L369.177 -164.805L368.185 -164.928Z",
    fill: "#CCD7FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.179 -160.816L355.41 207.266L356.403 207.389L402.172 -160.692L401.179 -160.816Z",
    fill: "#CCD7FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.273 -156.691L388.504 211.39L389.496 211.514L435.265 -156.567L434.273 -156.691Z",
    fill: "#CCD7FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.267 -152.579L421.498 215.502L422.49 215.626L468.26 -152.455L467.267 -152.579Z",
    fill: "#CCD7FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.261 -148.466L454.492 219.615L455.485 219.738L501.254 -148.343L500.261 -148.466Z",
    fill: "#CCD7FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.24953 -212.347L-40.5195 155.734L-39.5271 155.858L6.24193 -212.223L5.24953 -212.347Z",
    fill: "#CCD7FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2437 -208.234L-7.52539 159.847L-6.53299 159.97L39.2361 -208.111L38.2437 -208.234Z",
    fill: "#CCD7FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2378 -204.122L25.4688 163.959L26.4611 164.082L72.2302 -203.999L71.2378 -204.122Z",
    fill: "#CCD7FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.232 -200.01L58.4629 168.071L59.4553 168.195L105.224 -199.886L104.232 -200.01Z",
    fill: "#CCD7FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M884.2 6.89999L-179.5 -129.3L-179.4 -130.5L884.3 5.7L884.2 6.89999Z",
    fill: "#CCD7FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M880.099 39.9L-183.601 -96.3L-183.501 -97.5L880.199 38.7L880.099 39.9Z",
    fill: "#CCD7FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M875.9 72.9L-187.7 -63.3L-187.6 -64.5L876.1 71.7L875.9 72.9Z",
    fill: "#CCD7FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.099 103.7L-191.601 -32.5L-191.401 -33.7L872.299 102.5L872.099 103.7Z",
    fill: "#CCD7FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M868 136.7L-195.7 0.500049L-195.5 -0.699951L868.2 135.5L868 136.7Z",
    fill: "#CCD7FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M863.899 169.7L-199.801 33.5L-199.601 32.3L863.999 168.5L863.899 169.7Z",
    fill: "#CCD7FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M859.8 202.7L-203.9 66.5L-203.7 65.3L859.9 201.5L859.8 202.7Z",
    fill: "#CCD7FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M855.699 235.7L-208.001 99.5L-207.801 98.3L855.799 234.5L855.699 235.7Z",
    fill: "#CCD7FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M851.599 268.7L-212.101 132.5L-212.001 131.3L851.699 267.5L851.599 268.7Z",
    fill: "#CCD7FD"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M651.3 -13.3999L645.1 34.8001C644.5 39.3001 647.7 43.4001 652.2 44.0001L699.6 50.1001C704.1 50.7001 707.3 54.8001 706.7 59.3001L705 73.6001C704.4 78.1001 707.6 82.2001 712.1 82.8001L826.9 97.0001C831.4 97.6001 835.5 94.4001 836.1 89.9001L842 42.9001C842.6 38.4001 846.7 35.2001 851.2 35.8001L889.1 40.5001",
    stroke: "#FFE600",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M677.099 50.8C679.143 50.8 680.799 49.1435 680.799 47.1C680.799 45.0566 679.143 43.4 677.099 43.4C675.056 43.4 673.399 45.0566 673.399 47.1C673.399 49.1435 675.056 50.8 677.099 50.8Z",
    fill: "#FFE600"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M705.5 70.4C707.543 70.4 709.2 68.7435 709.2 66.7C709.2 64.6565 707.543 63 705.5 63C703.456 63 701.8 64.6565 701.8 66.7C701.8 68.7435 703.456 70.4 705.5 70.4Z",
    fill: "#FFE600"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M440.999 -16.7L392.799 -23.5C388.299 -24.1 384.099 -21 383.499 -16.5L376.899 30.9C376.299 35.4 372.099 38.5 367.599 37.9L353.399 35.9C348.899 35.3 344.699 38.4 344.099 42.9L328.399 157.4C327.799 161.9 330.899 166.1 335.399 166.7L382.299 173.1C386.799 173.7 389.899 177.9 389.299 182.4L384.199 220.3",
    stroke: "#FFE600",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M218.9 209L225.1 160.8C225.7 156.3 222.5 152.2 218 151.6L170.6 145.5C166.1 144.9 162.9 140.8 163.5 136.3L165.3 122C165.9 117.5 162.7 113.4 158.2 112.8L43.4002 98.5001C38.9002 97.9001 34.8002 101.1 34.2002 105.6L28.3002 152.6C27.7002 157.1 23.6002 160.3 19.1002 159.7L-18.7998 155",
    stroke: "#FFE600",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M380.2 12.0001C382.243 12.0001 383.9 10.3436 383.9 8.3001C383.9 6.25664 382.243 4.6001 380.2 4.6001C378.157 4.6001 376.5 6.25664 376.5 8.3001C376.5 10.3436 378.157 12.0001 380.2 12.0001Z",
    fill: "#FFE600"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M360.3 40.1001C362.343 40.1001 364 38.4435 364 36.4001C364 34.3566 362.343 32.7001 360.3 32.7001C358.256 32.7001 356.6 34.3566 356.6 36.4001C356.6 38.4435 358.256 40.1001 360.3 40.1001Z",
    fill: "#FFE600"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M839 71.4C841.043 71.4 842.7 69.7435 842.7 67.7C842.7 65.6565 841.043 64 839 64C836.956 64 835.3 65.6565 835.3 67.7C835.3 69.7435 836.956 71.4 839 71.4Z",
    fill: "#FFE600"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M767.6 76.7001C761.2 76.2001 746.3 77.5001 742 77.6001C738.8 77.7001 735.6 76.0001 735.6 75.5001C735.6 75.0001 739.4 75.7001 739.4 75.7001C739.4 75.7001 734.1 74.7001 734.3 74.0001C734.5 73.3001 737 74.3001 738.2 74.1001C737 74.2001 734.1 73.2001 733.8 72.5001C733.5 71.8001 738.3 72.6001 738.7 72.5001C738.4 72.5001 734.1 72.0001 734 71.0001C734 70.0001 741.6 71.2001 741.6 71.2001C741.6 71.2001 740.8 70.1001 740.8 69.0001C741.1 68.0001 744.2 70.6001 745.3 70.9001C746.4 71.2001 759.7 69.4001 764.8 67.1001C766.4 62.3001 766.2 49.9001 768 47.6001C770 45.1001 775.1 44.3001 774.4 50.1001C774.5 50.1001 774.2 77.1001 767.6 76.7001Z",
    fill: "#FCBD4C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M770.1 43.7C768.1 45.2 764.6 53.7 765.3 55.8C766 58 770.1 58.5 770.1 58.5L777 43.3C777 43.3 771.9 42.4 770.1 43.7Z",
    className: "illustration_primary_default"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M793.2 42.5C799.1 48.1 795.8 66.6 794.5 76.2C793.3 85 800.3 100.1 792.5 101.8C790.1 102.3 773.2 101.1 768.4 98.6C763.5 96.2 764.6 98.6 764.1 95C763.4 89.8 769.2 78.1 768.5 72.4C767.9 67.5 765.4 63.1 769 54.6C772.6 46.2 767.4 45.1 770.6 42.9C776.5 39 788 37.6 793.2 42.5Z",
    className: "illustration_primary_default"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M786.2 40.4001C787.6 42.4001 787.8 44.4001 785 46.1001C781.8 48.0001 777.8 47.2001 777 45.4001C775.9 43.1001 777.8 40.8001 779.4 39.9001C782.6 38.2001 784.7 38.3001 786.2 40.4001Z",
    fill: "#E1E4F7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M782.3 45.4C784.9 45.3 786.6 43.9 786.5 41.3L786.8 34.1C786.7 31.5 783.9 32.8 781.2 33C778.6 33.1 776.6 35.4 776.7 38L776.9 41.9C777.2 44.5 779.7 45.6 782.3 45.4Z",
    fill: "#FCBD4C"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M766.3 14.8C765.9 19.3 764.3 27.9 766.1 34.1C767.9 40.3 773.9 45.7 783 39.5C788.5 35.7 789.2 29.2 787.8 24.5C787.4 23.1 789 14.2 787.6 12.9C784.8 10.4 766.5 13.4 766.3 14.8Z",
    fill: "#FCBD4C"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M772.4 28.9C772.4 28.9 771.4 30.4 771.2 31.7C771 33.1 772.8 32.6 772.8 32.6",
    stroke: "black",
    strokeWidth: 0.8294,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M791.6 26.1001C791.6 26.1001 794.1 19.1001 788.3 13.2001C782.5 7.30007 777.2 8.00007 771.2 10.0001C764.9 12.1001 763.5 20.8001 763.5 20.8001C763.5 20.8001 778.8 19.8001 781.6 18.4001C782.8 23.9001 786.1 26.1001 791.6 26.1001Z",
    className: "illustration_primary"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M787 30.5C787 30.5 789.2 31.1 790.3 30.7C792 30 792.3 27.5 791.5 26C790.7 24.6 787.7 24.9 786.8 25.7",
    fill: "#FCBD4C"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M790.3 19.9C793.89 19.9 796.8 16.9899 796.8 13.4C796.8 9.81017 793.89 6.90002 790.3 6.90002C786.71 6.90002 783.8 9.81017 783.8 13.4C783.8 16.9899 786.71 19.9 790.3 19.9Z",
    className: "illustration_primary"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M778.9 30.4C780.944 30.4 782.6 28.7435 782.6 26.7C782.6 24.6565 780.944 23 778.9 23C776.857 23 775.2 24.6565 775.2 26.7C775.2 28.7435 776.857 30.4 778.9 30.4Z",
    stroke: "#131A46",
    strokeWidth: 0.6651,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M767 31.1C769.043 31.1 770.7 29.4434 770.7 27.4C770.7 25.3565 769.043 23.7 767 23.7C764.956 23.7 763.3 25.3565 763.3 27.4C763.3 29.4434 764.956 31.1 767 31.1Z",
    stroke: "#131A46",
    strokeWidth: 0.6651,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M782.6 26.5L787.4 25",
    stroke: "#131A46",
    strokeWidth: 0.6651,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M775.2 26.3C775.2 26.3 774.2 25.3 772.8 25.4C771.3 25.5 770.6 26.4 770.6 26.4",
    stroke: "#131A46",
    strokeWidth: 0.6651,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M790.6 16.8C790.6 16.8 790.7 15.9 789.4 14.2C788 12.5 786.8 12.1 786.8 12.1",
    stroke: "white",
    strokeWidth: 0.4838,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M790 27.2001C790 27.2001 787.9 26.6001 788 28.0001",
    stroke: "black",
    strokeWidth: 0.8294,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M778.3 41.8C778.3 41.8 783.9 39.9 785.8 36.8",
    stroke: "black",
    strokeWidth: 0.2895,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M767 28.7C767.442 28.7 767.8 28.3418 767.8 27.9C767.8 27.4581 767.442 27.1 767 27.1C766.558 27.1 766.2 27.4581 766.2 27.9C766.2 28.3418 766.558 28.7 767 28.7Z",
    className: "illustration_primary"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M776.6 34.9C776.6 34.9 776 36.9 771.2 36.6",
    stroke: "black",
    strokeWidth: 0.8294,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M777.9 27.8001C778.341 27.8001 778.7 27.4419 778.7 27.0001C778.7 26.5582 778.341 26.2001 777.9 26.2001C777.458 26.2001 777.1 26.5582 777.1 27.0001C777.1 27.4419 777.458 27.8001 777.9 27.8001Z",
    className: "illustration_primary"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M761.6 119.9C761.7 115.4 763.5 102.6 763.5 94.5C763.5 94.5 787.9 90.8 797 93.9C796.6 108.3 800 98.6 800.1 119.9H761.6Z",
    className: "illustration_tertiary"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M763.3 94.5C763.3 93.5 763.3 92.7 763.9 91.9C763.9 91.9 786.8 88.2 795.9 91.3C795.9 92.2 796.9 93.9 796.9 93.9C796.9 93.9 774.1 92.4 763.3 94.5Z",
    fill: "#E1E4F7"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M748.499 73.9001L729.799 74.5C728.899 74.5 728.199 74.0001 728.199 73.4001L727.899 63.1C727.899 62.4 728.599 61.9001 729.399 61.9001L748.099 61.3C748.999 61.3 749.699 61.8001 749.699 62.4001L749.999 72.7C749.999 72.9 749.899 73.2001 749.799 73.4001C749.499 73.7001 749.099 73.9001 748.499 73.9001Z",
    className: "illustration_primary"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M747.8 73.1L730.4 73.6C729.6 73.6 729 73.2 728.9 72.6L728.6 63.4001C728.6 62.8001 729.2 62.3 730 62.3L747.4 61.8C748.2 61.8 748.8 62.2 748.9 62.8L749.2 72C749.2 72.2 749.1 72.4 749 72.6C748.8 72.9 748.3 73.1 747.8 73.1Z",
    className: "illustration_primary_default"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_20994_306981",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 728,
    y: 61,
    width: 22,
    height: 13
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M747.8 73.1L730.4 73.6C729.6 73.6 729 73.2 728.9 72.6L728.6 63.4001C728.6 62.8001 729.2 62.3 730 62.3L747.4 61.8C748.2 61.8 748.8 62.2 748.9 62.8L749.2 72C749.2 72.2 749.1 72.4 749 72.6C748.8 72.9 748.3 73.1 747.8 73.1Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_20994_306981)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M696.8 70L715.3 69.4L715.6 77.5L724.5 77.2L724.4 73.2L731.8 72.9L732.1 81L721.4 81.4L721.6 87.9",
    stroke: "#E6E8F5",
    strokeWidth: 0.6316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.299 86.8L706.899 74.8L719.399 74.4L719.599 79.4L744.999 78.5L744.399 57.8L747.999 57.7L748.799 84.8L756.399 84.6L755.899 69.9L733.099 70.6L732.599 54.6",
    stroke: "#2A9DD6",
    strokeWidth: 0.6316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.399 77L711.299 76.5999L711.199 71.4L728.299 70.9L728.499 76.9L737.199 76.5999L736.899 64.4L741.199 64.1999L740.999 56.2",
    stroke: "#FFE600",
    strokeWidth: 0.6316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739 65.8C738.3 65.8 737.8 66.4 737.8 67.1C737.8 67.8 739.1 69.5 739.1 69.5C739.1 69.5 740.3 67.8 740.3 67.1C740.3 66.3 739.7 65.7 739 65.8ZM739.1 67.7C738.7 67.7 738.4 67.4 738.4 67C738.4 66.6 738.7 66.3 739 66.3C739.3 66.3 739.7 66.6 739.7 67C739.7 67.4 739.4 67.7 739.1 67.7Z",
    fill: "#FFE600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M746.5 66.6C746.1 66.6 745.7 67 745.7 67.5C745.7 68 746.6 69 746.6 69C746.6 69 747.4 67.9 747.4 67.4C747.4 67 747 66.6 746.5 66.6ZM746.6 67.9C746.4 67.9 746.2 67.7 746.2 67.5C746.2 67.3 746.4 67.1 746.6 67C746.8 67 747 67.2 747 67.4C747 67.7 746.8 67.9 746.6 67.9Z",
    fill: "#2A9DD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.5 77.2999V74.7999L741.6 75.4999L741.5 71.7999L735.3 71.9999L735.6 81.9999L743.9 81.6999L744.2 90.8999",
    stroke: "#E6E8F5",
    strokeWidth: 0.6316,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M734.799 15.2001C724.299 16.0001 716.399 25.2001 717.199 35.7001C717.999 46.3001 738.999 69.6001 738.999 69.6001C738.999 69.6001 756.099 43.4001 755.299 32.8001C754.499 22.3001 745.299 14.4001 734.799 15.2001ZM736.999 43.7001C731.799 44.1001 727.299 40.2001 726.899 35.0001C726.499 29.8001 730.399 25.3001 735.599 24.9001C740.799 24.5001 745.299 28.4001 745.699 33.6001C746.099 38.7001 742.199 43.3001 736.999 43.7001Z",
    fill: "#FFE600"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M765 68.4001C761 62.9001 760.2 51.6001 755.7 45.8001C755 44.9001 754.6 44.3001 754 44.5001C752.2 45.0001 750.8 45.3001 750 45.4001C749.1 45.5001 747.5 45.8001 747.4 44.9001C747.4 44.7001 749.4 44.4001 749.8 44.0001C750.3 43.5001 750.3 43.2001 750.3 43.2001C750.3 43.2001 749 43.7001 747.7 43.9001C746.6 44.2001 745.7 43.8001 745.6 43.4001C745.5 43.0001 746.4 43.2001 747.4 42.7001C748.3 42.3001 748.8 42.2001 749.6 41.8001C748.8 41.8001 748.1 42.0001 747.3 42.1001C746.3 42.2001 744.8 42.4001 744.8 41.3001C744.8 40.8001 745.8 40.7001 746.8 40.4001C747.7 40.2001 748.8 40.0001 749 39.9001C748.6 40.0001 744.9 39.9001 744.6 38.8001C744.4 38.2001 747 38.3001 749.3 38.0001C751.3 37.7001 752.1 37.8001 753 37.4001C753.4 37.3001 753.9 36.8001 754 36.1001C754 35.5001 753.1 34.3001 753.5 33.8001C754.6 32.2001 755.7 37.0001 757.1 37.2001C759.2 37.6001 760 40.3001 760.5 41.2001C763.3 46.4001 767.9 56.2001 771 61.0001C775.2 59.4001 780.5 51.2001 784 50.5001C787.8 49.8001 789.1 53.3001 788.9 56.3001C788.8 56.6001 771.4 77.4001 765 68.4001Z",
    fill: "#FCBD4C"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M785.3 46.4001L777.9 53.0001C777.9 53.0001 777.4 55.5001 781 59.7001C784.7 63.9001 787.2 63.1001 787.2 63.1001C787.2 63.1001 795.1 55.6001 795.5 52.3001C795.9 49.0001 792.1 47.2001 790.6 46.5001C789.1 45.8001 785.3 46.4001 785.3 46.4001Z",
    className: "illustration_primary_default"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M786.3 61.4001C786.3 61.4001 781.1 58.1001 779.7 53.5001",
    stroke: "#E1E4F7",
    strokeWidth: 0.4818,
    strokeMiterlimit: 10
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20994_306981"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 854,
    height: 160,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundWidgetMaps);
export default __webpack_public_path__ + "static/media/BackgroundWidgetMaps.542381af.svg";
export { ForwardRef as ReactComponent };